import React from "react";

export default class ProgressBar extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        let containerStyles = {
            height: 20,
            width: "100%",
            backgroundColor: "lightgray",
            borderRadius: 50,
            margin: 0,
            textAlign: "center",
            display: "-webkit-box",
        };

        let fillerStyles = {
            height: "100%",
            width: `${this.props.progress}%`,
            backgroundColor: `${this.props.bgcolor}`,
            borderRadius: "inherit",
            textAlign: "center",
            display: "-webkit-box",
        };

        let labelStyles = {
            padding: 5,
            color: "white",
        };

        let bar = this.props.progress > 25 ?
            <div style={containerStyles}>
                <div style={fillerStyles}>
                    <span style={labelStyles}>{`${this.props.legend}`}</span>
                </div>
            </div>
            :
            <div style={containerStyles}>
                <div style={fillerStyles}>
                </div>
                <span style={labelStyles}>{`${this.props.legend}`}</span>
            </div>

        return (
            bar
        )
    }
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProgressBar/ProgressBar.js